import axios from '@/lib/axios';
import { FixedAsset, Plan, Product } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2310. 支払いリトライ要求
 * [PUT] /workspace_payment_failure/:token
 */
type Props = {
  token: string;
  setup_intent_id: string;
};

const reregisterPaymentInfo = (props: Props): Promise<any> => {
  return axios.put(`/api/workspace_payment_failures/${props.token}`, props);
};

export const useReregisterPaymentInfo = () => {
  return useMutation({
    mutationFn: reregisterPaymentInfo,
  });
};
